import { APP_ROUTES, FEATURE_TOGGLES } from '@constants/constants';
import { SecurityScope } from '@/utils/acl-utils';
import { IUserWrapper } from '@/stores/currentUserApi';

import { INavigationItem } from './HeaderTypes';

export const mainNavigationData: INavigationItem[] = [
  {
    text: 'common:main-navigation.Dashboard',
    href: APP_ROUTES.DASHBOARD,
    id: '{DF4B8467-8C26-4C7D-9490-C575A4273DDE}',
    display: function () {
      return true;
    }
  },
  {
    text: 'common:main-navigation.OrderLists',
    href: APP_ROUTES.ORDERLISTS,
    id: '{DF4B1234-0006-4C7D-9490-C575A4273DDE}',
    security: SecurityScope.ORDER_LISTS_VIEW,
    display: function (user: IUserWrapper) {
      return user?.isBusinessAccount ?? false;
    }
  },
  {
    text: 'common:main-navigation.OrdersHistory',
    href: APP_ROUTES.ORDER_HISTORY,
    id: '{09b1fe7c-3e50-4f25-a690-237cb1be6ca1}',
    security: SecurityScope.ORDERS_VIEW,
    display: function () {
      return true;
    }
  },
  {
    text: 'common:main-navigation.Catalog',
    href: APP_ROUTES.CATALOG,
    id: '{f2a8daf6-f205-4da5-be87-8e352e479c70}',
    security: SecurityScope.CATALOG_VIEW,
    featureToggle: FEATURE_TOGGLES.CATALOG,
    display: function (user: IUserWrapper) {
      return user?.isBusinessAccount ?? false;
    }
  },
  {
    text: 'common:main-navigation.KnowledgeBase',
    href: APP_ROUTES.KNOWLEDGE_BASE,
    id: '{f2a8daf6-f2a8daf6-4d20-b474-C575A4273DDE}',
    display: function () {
      return true;
    }
  },
  {
    text: 'common:main-navigation.Webshop',
    href: APP_ROUTES.WEBSHOP,
    id: '{22c8c7fd-cad8-4d20-b474-26a5f26192c3}',
    display: function (user: IUserWrapper, isFeatureEnabled: (key: string) => boolean) {
      // always execute the hook otherwise React throws an error

      const hasCatalogFeature = isFeatureEnabled && isFeatureEnabled(FEATURE_TOGGLES.CATALOG);

      // do not display for business users
      if (!user?.isBusinessAccount) {
        return true;
      }
      // If catalog feature is enabled, do not display 'webshop' link
      if (hasCatalogFeature) {
        return false;
      }

      return true;
    }
  }
];
